// eslint-disable-next-line no-restricted-imports
import { getTranslate as _getTranslate } from "@tolgee/svelte";
import type { DefaultParamType, NsFallback, TFnType, TranslationKeyUnsafe } from "@tolgee/web";
import { fromStore } from "svelte/store";

export function getTranslate(ns?: NsFallback): {
	t: TFnType;
	isLoading: boolean;
	/** Allows unknown keys */
	tUnsafe: TFnType<DefaultParamType, string, TranslationKeyUnsafe>;
} {
	const translate = _getTranslate(ns);
	const t = fromStore(translate.t);
	const isLoading = fromStore(translate.isLoading);

	return {
		get t(): TFnType<DefaultParamType> {
			return t.current;
		},
		get tUnsafe(): TFnType<DefaultParamType, string, TranslationKeyUnsafe> {
			return t.current as TFnType<DefaultParamType, string, TranslationKeyUnsafe>;
		},
		get isLoading(): boolean {
			return isLoading.current;
		},
	};
}
